/** @file Roving index over a list with disabled items: menus, tabs and the dialog focus trap share it. */

/**
 * Next enabled index from `current` in direction `delta`; `current` -1 means nothing is active yet.
 * Wraps around when `wrap` is set, otherwise stops at the edges; returns `current` when no enabled item is reachable.
 */
export function stepIndex(current: number, delta: 1 | -1, disabled: readonly boolean[], wrap: boolean): number {
  const count = disabled.length;
  let index = current < 0 ? (delta > 0 ? -1 : count) : current;
  for (let tried = 0; tried < count; tried += 1) {
    index += delta;
    if ((index < 0 || index >= count) && !wrap) return current;
    index = (index + count) % count;
    if (disabled[index] !== true) return index;
  }
  return current;
}
